import React, { useEffect, createElement } from 'react';
export function ClickTracker() {
  useEffect(() => {
    // Only run this code in the browser
    if (typeof window !== 'undefined') {
      // Create and inject the click tracking script
      const script = document.createElement('script');
      script.innerHTML = `
        // Detect clicks that lead from landers → main Shopify site
        function isToMainSite(a){
          try {
            return new URL(a.href).hostname.endsWith('irelief.us');
          } catch(e){
            return false;
          }
        }
        document.querySelectorAll('a,button').forEach(el=>{
          el.addEventListener('click', (e)=>{
            const a = e.currentTarget.tagName === 'A' ? e.currentTarget : e.currentTarget.closest('a');
            if (a && isToMainSite(a)) {
              // Track with Google Analytics
              if (typeof gtag === 'function') {
                gtag('event', 'cta_click', {
                  event_category: 'Engagement',
                  event_label: location.hostname
                });
              }
              // Track with Meta Pixel
              if (typeof fbq === 'function') {
                fbq('trackCustom', 'LanderCTAClick', {lander: location.hostname});
              }
            }
          });
        });
      `;
      document.body.appendChild(script);
    }
  }, []);
  return null;
}